import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import ChromePicker from 'react-color'
import { Formik } from 'formik';

//for connecting
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions/project';
import loadingImage from '../img/loading.svg'

class Projectmodal extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = { obj: {}, readOnly: true, allUsers: [] }
    }

    componentWillMount(){
        if( this.props.obj ){
            const appData = JSON.parse(localStorage.getItem('appData')) || {};
            const allUsers = [ ...this.props.app.work_space.users ]
            let readOnly = this.props.obj.owner.phone_number !== appData.user.phone_number;

            for(let i=0; i < allUsers.length; i++){
                allUsers[i]['selected'] = false;                
                for(let j=0; j< this.props.obj.users.length; j++){
                    if(allUsers[i]['phone_number'].trim() === this.props.obj.users[j]['phone_number'].trim() ){
                        allUsers[i]['selected'] = true;
                        break;              
                    }
                }
            }
            this.setState({obj: {...this.props.obj, 'workspace': this.props.app.work_space.id}, readOnly, allUsers});
        }else{
            const allUsers = [ ...this.props.app.work_space.users ]
            for(let i=0; i < allUsers.length; i++){
                allUsers[i]['selected'] = false;                
            }
            this.setState({'obj':{'name': '', 'color': '', 'users': [], 'workspace': this.props.app.work_space.id}, readOnly: false, allUsers: allUsers });
        }
    }

    handleChange = (index) => {
        let allUsers = this.state.allUsers
        if(this.state.allUsers[index].selected) 
        {
            allUsers[index].selected = false;
        }else{
            allUsers[index].selected = true;
        }
        this.setState({allUsers})
    }
    
    handleColorChange = (color) => {
        let changedObj = {...this.state.obj};
        changedObj.color = color.hex;
        this.setState({obj:{...changedObj}})
    }

    displayColorPicker = (color_) => {
        if(this.props.project.colorPicker){
            return (
            <div className='color-picker-popover' > 
                <div className='color-picker-cover' onClick={this.props.closeColorPicker} />
                <ChromePicker color={ color_ } onChange={ this.handleColorChange.bind(this) } disableAlpha={true} /> 
            </div>
            )
        }
        else return null;
    }
    
    userList = () => {
        let cursorStyle = {cursor:'pointer'};
        if(this.state.readOnly) cursorStyle.cursor = 'not-allowed';
        const mappedUsers = this.state.allUsers.map((user,index) => (
            <div className="col-md-4 checkbox-container " key={index}>
                <div className="checkbox-inline" >
                    <label style={cursorStyle} >
                         <input className="checkbox-container" disabled={this.state.readOnly} defaultChecked={user.selected} onChange={this.handleChange.bind(null,index)} type="checkbox" />
                          {user.name}
                    </label>
                </div>
            </div>
        ));
        return mappedUsers;
    }
  
    render() {
        const obj = this.state.obj;
        return (
          <Modal backdrop="static" show={true} onHide={this.props.toggleModal}>
            
                <Formik 
                    initialValues = {{
                        name: obj.name
                    }}
                    validate = {values => {
                        let errors = {};

                        if(!values.name) errors.name = 'وارد کردن نام پروژه الزامی است';
                        if(!this.state.obj.color) errors.color = 'یک رنگ معتبر برای پروژه انتخاب نمایید';
                        
                        return errors;
                    }}
                    onSubmit = {(values,actions) => {
                        const data = { ...this.state.obj, name: values.name, users: this.state.allUsers }
                        this.props.updateData( data, this.props.toggleModal )
                    }}
                    render = {
                        ({values, errors, touched, handleChange, handleSubmit, isSubmitting}) => (
                            <form className="project-form" name="projectForm" onSubmit={handleSubmit} >
                                <Modal.Header>
                                    <div className="col-md-3">
                                        <Modal.Title>
                                            { (this.props.project.objNumber>-1)? ('ویرایش پروژه'):('افزودن پروژه')}
                                        </Modal.Title>
                                    </div>
                                    <div className="pull-left">
                                        {(this.state.readOnly || this.props.app.loading!==0 ) || (<Button type="submit" bsStyle="success"  style={{marginLeft:'5px'}}>ذخیره</Button>) } 
                                        <Button bsStyle="danger" onClick={this.props.toggleModal}>بستن</Button>
                                    </div>
                                </Modal.Header>
                                <Modal.Body>
                                {
                                    (this.props.app.loading === 0)? 
                                    (                    
                                    <fieldset >
                                        <div className="row extended-row">
                                            <div className="col-md-6 form-group">
                                            <label>نام پروژه*</label>
                                            <input readOnly={this.state.readOnly} type="text" name="name" defaultValue={values.name} onChange={ handleChange } 
                                            className={
                                              errors.name && touched.name ? (
                                                'form-control invalid-input'
                                              ) : (
                                                'form-control'
                                              )
                                            } />
                                            {touched.name && errors.name && <div className="invalid-feedback" >{errors.name}</div>}
                                            </div>
                                            <div className="col-md-6 form-group">
                                            <label> رنگ</label>
                                            <div >
                                                <Button disabled={this.state.readOnly} bsStyle="default" onClick={this.props.changeColorPickerStatus} style={{display:"inline-block"}} > 
                                                    <div style={{float:"right"}} >
                                                        انتخاب رنگ
                                                    </div>
                                                    <div style={{float:"left",paddingTop:"2px"}} >
                                                        <span className="colorLabel" style={{backgroundColor:obj.color}} />
                                                    </div>
                                                </Button>
                                                { this.displayColorPicker(obj.color) }
                                            </div>
                                            { errors.color && <div className="invalid-feedback" >{errors.color}</div>}
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>

                                        <div className="row extended-row" >
                                            <div className="col-md-12 form-group extended-row">
                                                <label>انتخاب همکاران پروژه</label>
                                                <div className="row extended-row" >
                                                    { this.userList() }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="clearfix"></div>
                                    </fieldset>
                                    ):(
                                        <div className="project-modal-loading">
                                            <h4>
                                             درحال ارسال اطلاعات
                                            </h4>
                                            <img src={loadingImage} alt="loading" />
                                        </div>
                                    )
                                }
                                </Modal.Body>
                            </form>
                        )
                    }
                />
                
            <Modal.Footer>
                <p> 
                    پر کردن فیلد هایی که با * مشخص شده اجباری است
                </p>
            </Modal.Footer>
          </Modal>
      );
    }
  }
  
function mapStateToProps(state) {
  return {
    app: state.app,
    project: state.project
    }
}

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispachToProps)(Projectmodal);